<template>
  <base-icon
    :size="size"
    :icon="icon"
    :type="type"
    :icons="icons"
    :view-box="viewBox"
    :fill-rule="fillRule"
    :fill-color="fillColor"
    :stroke-color="strokeColor"
    :stroke-linecap="strokeLinecap"
    :stroke-linejoin="strokeLinejoin"
    :stroke-width="strokeWidth"
  />
</template>
<script>
import BaseIcon from './Icon';
import icons from './dashboard-icons.json';

export default {
  name: 'FluentIcon',
  components: {
    BaseIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    fillColor: {
      type: String,
      default: 'currentColor',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    fillRule: {
      type: String,
      required: false,
      default: 'nonzero',
    },
    strokeColor: {
      type: String,
      default: 'currentColor',
    },
    strokeLinecap: {
      type: String,
      default: 'none',
    },
    strokeLinejoin: {
      type: String,
      default: 'none',
    },
    strokeWidth: {
      type: String,
      default: '0',
    },
  },
  data() {
    return { icons };
  },
};
</script>
